import React from "react";
import { TranslatorSelect } from "../../common/TranslatorSelect";

const languageMap = ["US", "PL", "FR", "UK", "PT", "RU", "DE", "IT", "TR"];

const Container = ({ children }) => {
  return (
    <div className="bg-contain  py-6 background-image">
      <TranslatorSelect items={languageMap} />
      {children}
    </div>
  );
};

export default Container;
